import { supabase } from '../lib/supabaseClient'

export async function upsertPlan(params: { id: string; userId: string; advisorId?: string | null; plan: any; riskProfile?: any }) {
  const { id, userId, advisorId = null, plan, riskProfile } = params
  const { error } = await supabase
    .from('plans')
    .upsert({ id, user_id: userId, advisor_id: advisorId, plan, risk_profile: riskProfile }, { onConflict: 'id' })
  if (error) throw error
}

export async function fetchPlan(planId: string) {
  const { data, error } = await supabase
    .from('plans')
    .select('id, user_id, advisor_id, plan, risk_profile, created_at, updated_at')
    .eq('id', planId)
    .maybeSingle()
  if (error) throw error
  return data
}


